<div class="cart-container" *ngIf="selectedCustomer">
  <mat-card class="customer-info">
    <h3 class="card-title">Customer Details</h3>
    <p><strong>Name:</strong> {{ selectedCustomer.name }}</p>
    <p><strong>Contact:</strong> {{ selectedCustomer.phone }}</p>
  </mat-card>

  <mat-card class="cart-table">
    <!-- Header row: title left, actions right -->
    <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:8px;">
      <h3 class="card-title" style="margin:0">Cart Items</h3>

      <div style="display:flex;align-items:center;gap:6px;">
        <!-- Reload prices (selected rows if any selected; else all) -->
        <button
          *ngIf="!disableEdit && !readonly && selectedProducts?.length"
          mat-icon-button
          (click)="reloadPrices()"
          aria-label="Reload prices"
          matTooltip="Reload Prices (selected rows if any are selected, else all)">
          <mat-icon>autorenew</mat-icon>
        </button>

        <!-- Clear cart -->
        <button
          *ngIf="!disableEdit && !readonly && selectedProducts?.length"
          mat-icon-button
          color="warn"
          (click)="clearCart()"
          aria-label="Clear cart"
          matTooltip="Clear Cart">
          <mat-icon>delete_sweep</mat-icon>
        </button>
      </div>
    </div>


    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>#</th> <!-- New column for sequence number -->
            <th *ngIf="showSelection">
              <mat-checkbox [checked]="allSelected" (change)="toggleSelectAll($event.checked)"></mat-checkbox>
            </th>
            <th>Product</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of selectedProducts; let i = index"
              (click)="!readonly && openEditDialog(item)"
              [class.readonly-row]="readonly">
            <td>{{ i + 1 }}</td> <!-- Sequence number -->
            <td *ngIf="showSelection">
              <mat-checkbox [checked]="isSelected(item)" (change)="toggleSelection(item, $event.checked)"></mat-checkbox>
            </td>
            <td>{{ getProductName(item.productId) }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.price | currency:'INR':'symbol' }}</td>
            <td>{{ item.quantity * item.price | currency:'INR':'symbol' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="summary-row">
      <span class="net-label">Net Amount:</span>
      <span class="net-value">{{ totalAmount | currency:'INR':'symbol' }}</span>
    </div>

    <button *ngIf="!disableOrder" mat-raised-button color="primary" (click)="requestPlaceOrder()">Place Order</button>
    <app-slide-button *ngIf="!disableDraft" [slideText]="'Slide to Save as Draft'"
                      (slideComplete)="saveAsDraft()">
    </app-slide-button>

    <button *ngIf="!disableEdit" mat-flat-button class="black-white-btn" (click)="requestEdit()">
      {{ editButtonLabel }}
    </button>

    <button *ngIf="!disableDelete" mat-flat-button color="warn" (click)="deleteOrder()">
      Delete Order
    </button>
    <!-- Removed old bottom Clear Cart button -->
  </mat-card>
</div>

<div *ngIf="!selectedCustomer" class="no-customer">
  <mat-card class="no-customer-card">
    <p>No customer selected. Please return to select a customer.</p>
  </mat-card>
</div>
